export interface CityInfoModel {
  name: string;
}
